import { forwardRef } from 'react';

const DynamicComponent = ({
  tag = 'div', wrapTag, wrapProps = {}, children, className, ...attrs
}, ref) => {
  const Component = tag;
  const WrapperComponent = wrapTag;
  const rendered = <Component ref={ref} {...attrs} className={className}>{children}</Component>;
  if (WrapperComponent) {
    <WrapperComponent {...wrapProps}>
      { rendered }
    </WrapperComponent>;
  }
  return rendered;
};

export default forwardRef(DynamicComponent);
